import { Inline } from '@superdispatch/ui';
import { Box, TextBox } from '@superdispatch/ui-lab';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import { InstantIcon } from 'shared/icons/InstantIcon';
import { PostingLoadDTO } from '../data/dto/PostingLoadDTO';

interface PostingPriceLabelProps {
  load: PostingLoadDTO;
  isBookable: boolean;
}

export function PostingPriceLabel({
  load,
  isBookable,
}: PostingPriceLabelProps) {
  const formattedPrice = formatCurrency(load.price, {
    minimumFractionDigits: 0,
  });

  return !isBookable ? (
    <TextBox variant="heading-3">{formattedPrice}</TextBox>
  ) : (
    <Inline noWrap={true} space="xxsmall" verticalAlign="center">
      <TextBox variant="heading-3" color="blue">
        {formattedPrice}
      </TextBox>

      <Box fontSize="24px">
        <InstantIcon color="primary" fontSize="inherit" />
      </Box>
    </Inline>
  );
}
